import { Link } from '@tanstack/react-router';
import { ChevronRight, type LucideIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

interface AccountMenuItemProps {
  icon: LucideIcon;
  label: string;
  to?: string;
  onClick?: () => void;
  variant?: 'default' | 'destructive';
}

export function AccountMenuItem({
  icon: Icon,
  label,
  to,
  onClick,
  variant = 'default',
}: AccountMenuItemProps) {
  const content = (
    <>
      <div className="flex items-center gap-3">
        <Icon
          className={cn(
            'h-5 w-5',
            variant === 'destructive'
              ? 'text-destructive'
              : 'text-muted-foreground',
          )}
        />
        <span
          className={cn(
            'font-medium',
            variant === 'destructive' ? 'text-destructive' : 'text-foreground',
          )}
        >
          {label}
        </span>
      </div>
      <ChevronRight className="text-muted-foreground h-5 w-5" />
    </>
  );

  const className = cn(
    'flex items-center justify-between rounded-lg px-4 py-3 transition-colors',
    'hover:bg-muted',
  );

  if (to) {
    return (
      <Link to={to} className={className}>
        {content}
      </Link>
    );
  }

  return (
    <button type="button" onClick={onClick} className={cn(className, 'w-full')}>
      {content}
    </button>
  );
}
